var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5577 20.5328L18.1101 16.0834C21.438 11.6363 20.5306 5.33334 16.0834 2.0055C11.6363 -1.32234 5.33335 -0.414949 2.0055 4.03221C-1.32234 8.47937 -0.414949 14.7823 4.03221 18.1101C7.60454 20.7833 12.5111 20.7833 16.0834 18.1101L20.5328 22.5595C21.092 23.1187 21.9985 23.1187 22.5576 22.5595C23.1168 22.0004 23.1168 21.0938 22.5576 20.5347L22.5577 20.5328ZM10.0949 17.2514C6.14247 17.2514 2.93844 14.0473 2.93844 10.0949C2.93844 6.14247 6.14247 2.93843 10.0949 2.93843C14.0473 2.93843 17.2514 6.14247 17.2514 10.0949C17.2472 14.0455 14.0456 17.2472 10.0949 17.2514Z",
    fill: "#B4B4B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterSearch);
export default __webpack_public_path__ + "static/media/footer-search.531894fec9b1911b4afbb135015c55f5.svg";
export { ForwardRef as ReactComponent };